import { ACDLRoute } from './BaseRoute';

export const ZebraSitePath = 'https://zebra.com/';

export const Regulations = {
  PrivacyPolicy: new ACDLRoute('https://www.zebra.com/us/en/about-zebra/company-information/legal/privacy-statement.html'),
};

export const ACDLIo = {
  Tutorials: new ACDLRoute('https://docs.zebra.com/us/en/machine-vision/aurora/aurora-cloud-deep-learning-user-guide/c-zebra-acdl.html'),
};

export const ACDLPublicApi = {
  Documentation: new ACDLRoute('https://api.acdl.zebra.com'),
};
